import { xBaseTheme } from "@stoneage/XDL/types";

const spaceBase = 15;
const spaceX = spaceBase;
const spaceY = spaceBase;

export default {
  size: "green",
  columns: 12,

  spaces: {
    none: {
      x: 0,
      y: 0,
    },
    xs: {
      x: spaceX * (1 / 3),
      y: spaceY * (1 / 3),
    },
    sm: {
      x: spaceX * (2 / 3),
      y: spaceY * (2 / 3),
    },
    md: {
      x: spaceX,
      y: spaceY,
    },
    lg: {
      x: spaceX * (4 / 3),
      y: spaceY * (4 / 3),
    },
    xl: {
      x: spaceX * (5 / 3),
      y: spaceY * (5 / 3),
    },
    xxl: {
      x: spaceX * 2,
      y: spaceY * 2,
    },
  },
} as xBaseTheme["helpers"];
